import * as yup from 'yup';
import utils from 'shared/helpers/utils';
import { FORM_KEYS, NO_OF_CHARS } from 'shared/constant';

const { translateAnswer } = utils;
const { CRS } = FORM_KEYS;

/** e.g. format: +9651234123451 */
const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;

const crsQ1Schema = (intl, elementName, crsQ1) => {
  switch (elementName) {
    case CRS.CRS_Q1:
      return yup.object().shape({
        [CRS.CRS_Q1]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.RESIDENT_REPORTABLE_JURISDICTION:
      return yup.object().shape({
        [CRS.RESIDENT_REPORTABLE_JURISDICTION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ1, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          ),
      });
    default:
      return null;
  }
};

const crsQ2Schema = (intl, elementName, crsQ2) => {
  switch (elementName) {
    case CRS.CRS_Q2:
      return yup.object().shape({
        [CRS.CRS_Q2]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.RESIDENCE_ADDRESS:
      return yup.object().shape({
        [CRS.RESIDENCE_ADDRESS]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

const crsQ3Schema = (intl, elementName, crsQ3) => {
  switch (elementName) {
    case CRS.CRS_Q3:
      return yup.object().shape({
        [CRS.CRS_Q3]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.TELEPHONE_NUMBER:
      return yup.object().shape({
        [CRS.TELEPHONE_NUMBER]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN_MOBILE, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN_MOBILE }))
          .matches(phoneRegExp, intl.formatMessage({ id: 'validation.invalidMobileFormat' })),
      });
    default:
      return null;
  }
};

const crsQ4Schema = (intl, elementName, crsQ4) => {
  switch (elementName) {
    case CRS.CRS_Q4:
      return yup.object().shape({
        [CRS.CRS_Q4]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.HOLD_MAIL:
      return yup.object().shape({
        [CRS.HOLD_MAIL]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ4, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

const crsQ5Schema = (intl, elementName, crsQ5) => {
  switch (elementName) {
    case CRS.CRS_Q5:
      return yup.object().shape({
        [CRS.CRS_Q5]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.STANDING_INSTRUCTION:
      return yup.object().shape({
        [CRS.STANDING_INSTRUCTION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

const crsQ6Schema = (intl, elementName, crsQ6) => {
  switch (elementName) {
    case CRS.CRS_Q6:
      return yup.object().shape({
        [CRS.CRS_Q6]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case CRS.EFFECTIVE_POA:
      return yup.object().shape({
        [CRS.EFFECTIVE_POA]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(crsQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

const crsPageSchema = (intl, crsQ1, crsQ2, crsQ3, crsQ4, crsQ5, crsQ6) => yup.object().shape({
  [CRS.CRS_Q1]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.RESIDENT_REPORTABLE_JURISDICTION]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ1, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [CRS.CRS_Q2]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.RESIDENCE_ADDRESS]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [CRS.CRS_Q3]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.TELEPHONE_NUMBER]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [CRS.CRS_Q4]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.HOLD_MAIL]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ4, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [CRS.CRS_Q5]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.STANDING_INSTRUCTION]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [CRS.CRS_Q6]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [CRS.EFFECTIVE_POA]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(crsQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
});

const crsSchema = {
  crsQ1Schema,
  crsQ2Schema,
  crsQ3Schema,
  crsQ4Schema,
  crsQ5Schema,
  crsQ6Schema,

  crsPageSchema,
};

export default crsSchema;
